import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, Row, Col, UncontrolledTooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { sortBy } from "lodash";
import { getDeviceNetWorkHistory } from "../../../../redux/actions/deviceActions";
import { translate } from "../../../../utils/i18n";
import { BlockPlaceholder } from "../..";
import NetworkInfoChart from "./NetworkInfoChart";
import PeriodSelectorComp from "../../PeriodSelectorComp";
import "./NetworkInfo.scss";

const NetworkInfo = ({ isTableMode, device }) => {
  const today = new Date();
  const { _id, latestMessage, device_model } = device;
  const [dateRange, setDateRange] = useState({
    end: moment(today),
    start: moment().subtract(1, "days"),
  });
  const [networkHistoryData, setNetworkHistoryData] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");

  const [showHistoryModal, setShowHistoryModal] = useState(false);

  const handleGetDeviceNetWorkHistory = () => {
    getDeviceNetWorkHistory(_id, dateRange.start.toISOString(), dateRange.end.toISOString())
      .then((res) => {
        setNetworkHistoryData(res.data);
      })
      .catch((err) => {
        setErrorMsg(translate(err.message || "cantLoadData"));
      });
  };
  useEffect(() => {
    if (showHistoryModal) {
      handleGetDeviceNetWorkHistory();
    }
  }, [showHistoryModal, dateRange]);
  const toggleShowHistoryModal = () => {
    setShowHistoryModal((Prev) => !Prev);
  };

  return latestMessage &&
    ((device_model.network_type === "nbiot" && device_model.networkProtocol === "mqtt") ||
      (device_model.network_type === "nbiot" && device_model.networkProtocol === "http") ||
      (device_model.network_type === "lte" && device_model.networkProtocol === "http") ||
      (device_model.network_type === "sigfox" && device_model.networkProtocol === "sigfox")) ? (
    <>
      <div className="networkInfo cursor-pointer" onClick={toggleShowHistoryModal}>
        <i
          className={`icon__signal-strength signal-${latestMessage.signalStrength || "unknown"} ${isTableMode && " small"}`}
          id={`signalStrengthTooltip_${_id}`}
        >
          <span className="bar-1"></span>
          <span className="bar-2"></span>
          <span className="bar-3"></span>
          <span className="bar-4"></span>
          <span className="bar-5"></span>
        </i>
        {!("signalStrength" in latestMessage) ||
          (latestMessage.signalStrength === null && (
            <p className="m-0 text-center text-muted">
              <small>{translate("unknown")}</small>
            </p>
          ))}
        <UncontrolledTooltip placement="bottom" target={`signalStrengthTooltip_${_id}`}>
          <div>
            <p className="m-2">
              <span className="font-weight-bold text-muted">{translate("clickShowDetails")}</span>
            </p>
            {"network_type" in device_model && (
              <p className="m-2">
                <span className="font-weight-bold text-info">{translate("networkType")}:</span> {device_model.network_type}
              </p>
            )}
            {"networkProtocol" in device_model && (
              <p className="m-2">
                <span className="font-weight-bold text-info">{translate("networkProtocol")}:</span> {device_model.networkProtocol}
              </p>
            )}
            {"rssi" in latestMessage && (
              <p className="m-2">
                <span className="font-weight-bold text-info">{translate("RSSI")}:</span>{" "}
                {latestMessage.rssi !== null ? latestMessage.rssi : translate("unknown")}
              </p>
            )}
            {"rsrq" in latestMessage && (
              <p className="m-2">
                <span className="font-weight-bold text-info">{translate("RSRQ")}:</span>{" "}
                {latestMessage.rsrq !== null ? latestMessage.rsrq : translate("unknown")}
              </p>
            )}
          </div>
        </UncontrolledTooltip>
      </div>
      <Modal isOpen={showHistoryModal} toggle={toggleShowHistoryModal} size="lg" centered>
        <ModalHeader toggle={toggleShowHistoryModal}>{translate("networkStrength")}</ModalHeader>
        <ModalBody>
          <div>
            <Row>
              <Col sm="12" md="10" className="mt-1 d-flex  flex-column">
                <PeriodSelectorComp dateRange={dateRange} setDateRange={setDateRange} />
              </Col>
              <Col sm="12" md="2" className="mt-1 d-flex  flex-column">
                <Button color="info" outline onClick={() => handleGetDeviceNetWorkHistory()} block>
                  <FontAwesomeIcon icon={["fas", "sync-alt"]} className="mr-2" />
                  {translate("refresh")}
                </Button>
              </Col>
            </Row>
            <React.Fragment>
              <NetworkInfoChart data={networkHistoryData} networkProtocol={device_model.networkProtocol} />
            </React.Fragment>
          </div>
        </ModalBody>
      </Modal>
    </>
  ) : (
    <></>
  );
};

export default NetworkInfo;
